/**
 * @file logger.js
 * @description client-side logger.
 *              ships logs to Sentry
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * https://docs.sentry.io/platforms/javascript/guides/react/logs/
 *  
 * @author don michael
 * @since May 1, 2025
 */
import * as Sentry from "@sentry/react";

class Logger {

    consoleLogger(msg, attributeObj) {
        const nodeEnv = import.meta.env.VITE_APP_NODE_ENV;

        if (nodeEnv !== 'production') {
            console.log(msg, JSON.stringify(attributeObj));
        }
    }

    trace(msg, attributeObj) {
        if (Sentry && Sentry.isEnabled() === true) {
            Sentry.logger.trace(msg, attributeObj);
        }
        this.consoleLogger(msg, attributeObj);
    }

    debug(msg, attributeObj) {
        if (Sentry && Sentry.isEnabled() === true) {
            Sentry.logger.debug(msg, attributeObj);
        }
        this.consoleLogger(msg, attributeObj);
    }

    info(msg, attributeObj) {
        if (Sentry && Sentry.isEnabled() === true) {
            Sentry.logger.info(msg, attributeObj);
        }
        this.consoleLogger(msg, attributeObj);
    }

    warn(msg, attributeObj) {
        if (Sentry && Sentry.isEnabled() === true) {
            Sentry.logger.warn(msg, attributeObj);
        }
        this.consoleLogger(msg, attributeObj);
    }

    error(msg, attributeObj) {
        if (Sentry && Sentry.isEnabled() === true) {
            Sentry.logger.error(msg, attributeObj);
        }
        this.consoleLogger(msg, attributeObj);
    }

    fatal(msg, attributeObj) {
        if (Sentry && Sentry.isEnabled() === true) {
            Sentry.logger.error(msg, attributeObj);
        }
        this.consoleLogger(msg, attributeObj);
    }
}

export const logger = new Logger();